/* storybook-check-ignore */
import { Flex, Text, Link, Icon } from '@opendoor/bricks/core';

export default function RequestATourSupportSection({ title = 'Have questions?' }) {
  return (
    <Flex
      width="100%"
      padding="1rem"
      height="4.5rem"
      bg="#FAFAFA"
      border="1px solid"
      borderColor="neutrals40"
      borderRadius="semiRounded"
      flexDirection="row"
      gridGap="1rem"
      alignItems="center"
    >
      <Flex
        width="2.5rem"
        height="2.5rem"
        borderRadius="rounded"
        bg="neutrals0"
        boxShadow="0px 5px 10px rgba(29, 71, 123, 0.04), 0px 1px 5px rgba(29, 71, 123, 0.12)"
        alignItems="center"
        justifyContent="center"
      >
        <SupportIcon />
      </Flex>
      <Text fontWeight="semibold">
        {title}{' '}
        <Link
          aria-label={null}
          analyticsName=""
          href="tel:(512) 706-9938"
          alignItems="center"
          display="inline-flex"
        >
          Call us
          <Icon color="currentColor" name="chevron-right" size={12} />
        </Link>
      </Text>
    </Flex>
  );
}

function SupportIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.3335 3.33337C1.3335 2.2288 2.22893 1.33337 3.3335 1.33337H14.6668V10C14.6668 11.1046 13.7714 12 12.6668 12H10.6668L7.8335 14.6667L5.3335 12H1.3335V3.33337ZM4.66683 8.00004C4.66683 7.63185 4.96531 7.33337 5.3335 7.33337H10.6668C11.035 7.33337 11.3335 7.63185 11.3335 8.00004C11.3335 8.36823 11.035 8.66671 10.6668 8.66671H5.3335C4.96531 8.66671 4.66683 8.36823 4.66683 8.00004ZM5.3335 4.66671C4.96531 4.66671 4.66683 4.96518 4.66683 5.33337C4.66683 5.70156 4.96531 6.00004 5.3335 6.00004H10.6668C11.035 6.00004 11.3335 5.70156 11.3335 5.33337C11.3335 4.96518 11.035 4.66671 10.6668 4.66671H5.3335Z"
        fill="#222222"
      />
      <rect x="10" y="-1" width="6" height="6" rx="3" fill="#007F5E" />
      <rect x="10" y="-1" width="6" height="6" rx="3" stroke="white" strokeWidth="2" />
    </svg>
  );
}
